import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  ngrxEvent,
} from '@core/ngrx-legacy';
import {
  AssignMembersOptions,
  TellentPosition,
  UpdatePositionPayload,
} from '@core/tellent-positions-types';

const idSelector = (position: { guid: string }) => position.guid;

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<TellentPosition>()(
  'TellentPositions',
  {
    idSelector,
    customActions: adapter => {
      const _defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: state => adapter.markAsPending(state),
        createOnePessimistic: (
          state,
          payload: {
            name: string;
            correlationId: string;
          },
        ) =>
          adapter.markAsPending(state, {
            scope: null,
            entities: payload.correlationId ? [payload.correlationId] : [],
          }),
        updateOnePessimistic: (state, payload: { guid: string; position: UpdatePositionPayload }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.guid] }),
        removeOnePessimistic: (state, payload: { guid: string }) =>
          adapter.markAsPending(state, { scope: null, entities: [payload.guid] }),
        removeOnePessimisticSuccess: (state, payload: { data: { guid: string } }) =>
          adapter.removeOne(state, payload.data.guid),
        assignMembers: ngrxEvent<{
          positionGuid: string;
          membersGuids: string[];
          options?: AssignMembersOptions;
        }>(),
        assignMembersSuccess: (state, payload: { data: TellentPosition }) =>
          adapter.updateOne(state, payload.data),
        assignMembersFailed: (state, payload: { error: string }) => state,
        correctMembersPosition: ngrxEvent<{ positionGuid: string; membersGuids: string[] }>(),
        correctMembersPositionSuccess: ngrxEvent<void>(),
        correctMembersPositionFailed: (state, payload: { error: string }) => state,
        unassignMembers: ngrxEvent<{ positionGuid: string; membersGuids: string[] }>(),
        unassignMembersSuccess: (state, payload: { data: TellentPosition }) =>
          adapter.updateOne(state, payload.data),
        unassignMembersFailed: (state, payload: { error: string }) => state,
      };
    },
  },
);

export {
  selectors as TellentPositionsSelectors,
  reducer as TellentPositionsReducer,
  actions as TellentPositionsActions,
  namespace as TellentPositionsNamespace,
};
